/*
 * @providesModule ExternalAPIManager
 * 
 */

import QueryString from 'querystring-es3';

class ExternalAPIManager {
  get(url: string, params?: Object): Promise {
    return new Promise((resolve: (response: Object)=>void, reject: (error: Object)=>void) => {
      reject('ExternalAPIManager: get is not implemented');
    });
  }

  post(url: string, params?: Object, body?: Object): Promise {
    return new Promise((resolve: (response: Object)=>void, reject: (error: Object)=>void) => {
      const fetchRequest = {
        method: 'POST',
      };
      if (body) {
        fetchRequest.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
        fetchRequest.body = QueryString.stringify(body);
      }

      const requestURL = url + ((params || '') && '?' + QueryString.stringify(params));

      console.debug(`ExternalAPIManager: starting request to ${requestURL} with headers ${JSON.stringify(fetchRequest.headers)} and body ${JSON.stringify(fetchRequest.body, null, 2)}`);
      fetch(requestURL, fetchRequest).then((response: unknown): Object => {
        const json = response.json();
        if (!response.ok) {
          console.debug(`ExternalAPIManager: request to ${requestURL} failed with status code ${response.status}: ${JSON.stringify(json, null, 2)}`);
          reject(json);
        } else {
          console.debug(`ExternalAPIManager: request to ${requestURL} succeeded with response ${JSON.stringify(response, null, 2)}`);
          resolve(json);
        }
      }).catch((error: unknown) => { // gets here when the issue is at the network level (e.g. no internet connection)
        console.debug('ExternalAPIManager: unable to make request: ' + error);
        reject('Unable to make request');
      });
    });
  }
}

export default new ExternalAPIManager();
